import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { Button } from "primereact/button";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

const useTrOOPScheduleStepMessage = () => {
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();
  const {
    TROOP_SCHEDULE_STEP_MESSAGE_ADD,
    TROOP_SCHEDULE_STEP_MESSAGE_EDIT,
    TROOP_SCHEDULE_STEP_MESSAGE_DISPLAY,
    TROOP_SCHEDULE_STEP_EDIT,
    TROOP_SCHEDULE_STEP_DISPLAY,
  } = ROUTE_PATHS;

  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  let {
    selectedSteps = [],
    previousScreen = TROOP_SCHEDULE_STEP_EDIT,
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      tscScheduleName: selectedSteps[initialIndex].tscScheduleName,
      tscDescription: selectedSteps[initialIndex].tscDescription,
      tscVersion: selectedSteps[initialIndex].tscVersion,
      tscStepCount: selectedSteps[initialIndex].tscStepCount,
      tscCrossOverFlag: selectedSteps[initialIndex].tscCrossOverFlag,
      tscTroopAccumCompCode: selectedSteps[initialIndex].tscTroopAccumCompCode,
      tscDrugSpendAccumComp: selectedSteps[initialIndex].tscDrugSpendAccumComp,
      tsdStepNumber: selectedSteps[initialIndex].tsdStepNumber,
      tsdTroopAmount: selectedSteps[initialIndex].tsdTroopAmount,
      tsdDrugSpend: selectedSteps[initialIndex].tsdDrugSpend,
      tsdPlanCode: selectedSteps[initialIndex].tsdPlanCode,
      tsdPlanEffDate: selectedSteps[initialIndex].tsdPlanEffDate,
    },
  } = currentState;

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [data, setData] = useState([]); /* TrOOP Schedule Step Message Data */
  const [paramsData, setParamsData] = useState(initialParamsData); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();

  const screen_title = "TrOOP Schedule Step Message";
  const screenNumber = "RCTSM001";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "tscScheduleName",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "tscDescription",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "Version",
      name: "tscVersion",
      label: "Version",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
    {
      fieldLabel: "Steps",
      name: "tscStepCount",
      label: "Steps",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
    {
      fieldLabel: "TSC Cross Over Flag*ALL values",
      name: "tscCrossOverFlag",
      label: "Cross Over",
      type: "dropdown",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
    {
      fieldLabel: "TSC Troop Accum Comp Code*ALL values",
      name: "tscTroopAccumCompCode",
      label: "TrOOP Accum Code",
      type: "dropdown",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
    ...(selectedSteps[currentIndex].tscVersion !== "01"
      ? [
          {
            fieldLabel: "TSD Drug Spend Accum Comp*ALL values",
            name: "tscDrugSpendAccumComp",
            label: "Drug Spend Accum Code",
            type: "dropdown",
            fieldNature: "readOnly",
            value: "",
            maxLength: 2,
          },
        ]
      : []),
    {
      fieldLabel: "Step",
      name: "tsdStepNumber",
      label: "Step",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
    {
      fieldLabel: "TrOOP Maximum Amount",
      name: "tsdTroopAmount",
      label: "TrOOP Maximum Amount",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 9,
    },
    ...(selectedSteps[currentIndex].tscVersion !== "01"
      ? [
          {
            fieldLabel: "Drug Spend Maximum Amount",
            name: "tsdDrugSpend",
            label: "Drug Spend Maximum Amount",
            type: "text",
            fieldNature: "readOnly",
            value: "",
            maxLength: 9,
          },
        ]
      : []),
    {
      fieldLabel: "Plan Override",
      name: "tsdPlanCode",
      label: "Plan Override",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Plan From Date",
      name: "tsdPlanEffDate",
      label: "Plan From Date",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 7,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  //   const dropdownOptions = [];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Add TrOOP Schedule Step Message",
      button_handeler: () => {
        navigateToPage(TROOP_SCHEDULE_STEP_MESSAGE_ADD, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            schedule: initialParamsData.tscScheduleName,
            stepNumber: initialParamsData.tsdStepNumber,
            currentIndex: 0,
          },
        ]);
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        navigateToPage(TROOP_SCHEDULE_STEP_MESSAGE_EDIT, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      },
    },
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        navigateToPage(TROOP_SCHEDULE_STEP_MESSAGE_DISPLAY, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      },
    },
  ];

  const handleBack = () => {
    console.dir(previousState);
    if (currentIndex < selectedSteps.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const viewTroopMessageDetails = (messageCode) => {
    const message = {
      message: "navigate-to-presto",
      programCode: "RCMSG008",
      parameters: { msgMessageCde: messageCode },
    };
    window.top?.postMessage(message, "*");
  };

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Sequence",
      field: "tsmSeqNbr",
    },
    {
      header: "Code",
      field: "tsmMessageCde",
      body: (rowData) => {
        return (
          <Button
            label={rowData.tsmMessageCde}
            link
            onClick={(e) => {
              viewTroopMessageDetails(rowData.tsmMessageCde);
              // navigateToAccumsListDetails(rowData);
            }}
          />
        );
      },
    },
    {
      header: "Type",
      field: "tsmMessageType",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "tsmSeqNbr";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/tsmTroopStepMessage`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
          tsmSeqNbr: rowData[parmKey],
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const dropdownOptions = [
    { field_label: "TSC Cross Over Flag", condition: "*ALL values" },
    { field_label: "TSC Troop Accum Comp Code", condition: "*ALL values" },
    { field_label: "TSD Drug Spend Accum Comp", condition: "*ALL values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteTrOOPScheduleStepMessage = () => {
    if (selectedOption === "yes") {
      const params = { ...paramsData, tsmSeqNbr: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/tsmTroopStepMessage", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/tsmTroopStepMessage/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteTrOOPScheduleStepMessage,
    setSelectedOption,
  };
};

export default useTrOOPScheduleStepMessage;
